import { REVIEWS_STATE, TripReasonFilter } from './constants'
import { logosConfig } from 'client/components/RatingComments'

export interface Review {
  title: string
  author: string
  stars: number
  publishedDate: string
  text: string
  readMore: string
  verificationSource: keyof typeof logosConfig
  managementResponses: Array<{
    date: string
    text: string
  }>
}

export interface Reviews {
  reviews: Array<Review>
  reviewsPaginated: Array<Review>
  property: {
    source: string
  }
  pagination: {
    last: number
    page: number
    prev?: number
    next?: number
    total: number
  }
}

export interface ReviewsState {
  [REVIEWS_STATE]: {
    error: null
    isFetching: boolean
    data: Reviews
    filter?: TripReasonFilter
  }
}

const state: ReviewsState = {
  [REVIEWS_STATE]: {
    error: null,
    isFetching: false,
    filter: undefined,
    data: {
      reviews: [],
      reviewsPaginated: [],
      pagination: {
        last: 0,
        page: 0,
        prev: 0,
        next: 0,
        total: 0,
      },
      property: {
        source: '',
      },
    },
  },
}

export default state
